import { Space } from 'antd';
import PrimaryButton from '../../../components/ui/PrimaryButton';
import { DownloadOutlined } from '@ant-design/icons';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import DateRangeSelector from '../../../components/ui/filters/DateRangeFilter';
import Search from 'antd/es/input/Search';

const MaterialStatusHeaderFilter = ({
  startDate,
  endDate,
  handleExport,
}: {
  startDate: string | undefined | null;
  endDate: string | undefined | null;
  handleExport: () => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleInputProderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSearchParams((prev) => {
      prev.set('proder', event.target.value);
      return prev;
    });
  };

  const handleInputPONOChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSearchParams((prev) => {
      prev.set('pono', event.target.value);
      return prev;
    });
  };

  const handleInputSKUChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchParams((prev) => {
      prev.set('sku', event.target.value);
      return prev;
    });
  };

  return (
    <>
      <div className={'flex p-4 justify-between'}>
        <Space direction="vertical">
          <Space>
            <label htmlFor="location">Date Coverage:</label>
            <DateRangeSelector startDate={startDate} endDate={endDate} />
            <label htmlFor="location">P.O. Number:</label>
            <Search
              placeholder={'P.O. Number'}
              className={'w-52'}
              allowClear
              value={searchParams.get('pono') || ''}
              onChange={handleInputPONOChange}
            />
          </Space>
          <Space>
            <label htmlFor="location">Proder:</label>
            <Search
              placeholder={'Proder'}
              className={'w-52'}
              allowClear
              value={searchParams.get('proder') || ''}
              onChange={handleInputProderChange}
            />
            <label htmlFor="location">SKU:</label>
            <Search
              placeholder={'SKU'}
              className={'w-52'}
              allowClear
              value={searchParams.get('sku') || ''}
              onChange={handleInputSKUChange}
            />
          </Space>
        </Space>
        <PrimaryButton
          icon={<DownloadOutlined />}
          onClick={handleExport}
          label={'Export'}
        />
      </div>
    </>
  );
};

export default MaterialStatusHeaderFilter;
